import React, { createContext, useContext } from 'react';
import { useFlux } from '../../state/useFlux';
const initialState = {
  projects: [],
  selectedProject: null,
  modal: {
    configButtonLoading: false,
    content: 'config',
    loading: false,
    open: false,
    result: '',
    runButtonLoading: false,
    selectedReportId: null
  }
};
const ReportQAContext = createContext(undefined);
export const ReportQAContextProvider = ({
  children
}) => {
  const fluxState = useFlux(initialState);
  return <ReportQAContext.Provider value={fluxState}>
      {children}
    </ReportQAContext.Provider>;
};
export const useReportQAContext = () => {
  const context = useContext(ReportQAContext);
  if (context === undefined) {
    throw new Error('useReportQAContext must be used within a ReportQAContextProvider');
  }
  return context;
};